import React from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { INPUT_REGEX } from 'src/utilities/regexPatterns';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface InvoiceContactCityProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function InvoiceContactCityControl({
  name,
  id,
  rules,
}: InvoiceContactCityProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      label={addAsterisk('City', rules)}
      name={name}
      id={id}
      inputSize="medium"
      control={control}
      error={errors[name]}
      blockWidth
      placeholder="e.g. New York"
      rules={{
        maxLength: {
          value: 60,
          message: 'Max value 60',
        },
        pattern: {
          value: INPUT_REGEX,
          message: 'City is invalid',
        },
        ...rules,
      }}
    />
  );
}
